import { Styles, generateClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const licenseFooterClasses = generateClasses('LicenseFooter', ['root', 'lsyLogo', 'copyright'] as const);

const styles: Styles = ({ theme, theme: { palette } }) => {
  const {
    aboutDialog: { lufthansaSystemsLogoHeight: lsyLogoHeight },
  } = getAppFrameTheme(theme);

  return {
    [`&&.${licenseFooterClasses.root}`]: {
      marginTop: 'auto',
      marginLeft: 0,
      marginRight: 0,
    },

    [`.${licenseFooterClasses.lsyLogo}`]: {
      height: lsyLogoHeight,
    },

    [`.${licenseFooterClasses.copyright}`]: {
      fontFamily: 'LufthansaTextWeb',
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0.4,
      color: palette.grey[600],
    },
  };
};

export default styles;
